<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h4 class="card-title mb-0 flex-grow-1">Add New Campaign</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<div class="container">
					<div class="row">
						<div class="col-12">
							<ul ngbNav #nav="ngbNav" [activeId]="1" class="nav nav-tabs nav-tabs-custom nav-success mb-3">
								<li [ngbNavItem]="1">
									<a ngbNavLink> <i class="ri-profile-fill me-1 align-bottom"></i>Basic </a>
									<ng-template ngbNavContent>
										<form [formGroup]="formBasicInfo">
											<div class="container container-margin">
												<div class="row">
													<div class="col-12">
														<h3>
															<strong>Campaign Informatisdfsdfdson</strong>
														</h3>
													</div>
												</div>
												<div class="row mt-3">
													<div class="col-3">
														<label class="form-label">Campaign name *</label>
														<input type="text" class="form-control money-green" formControlName="name" [class.is-invalid]="formBasicInfo.get('name').touched && formBasicInfo.get('name').invalid" [class.is-valid]="formBasicInfo.get('name').touched && formBasicInfo.get('name').valid" />
													</div>
													<div class="col-3">
														<label class="form-label">Alias owner *</label>
														<select class="form-control money-green" formControlName="alias" [class.is-invalid]="formBasicInfo.get('alias').touched && formBasicInfo.get('alias').invalid" [class.is-valid]="formBasicInfo.get('alias').touched && formBasicInfo.get('alias').valid">
															<option value="">Select alias owner</option>
															<option value="{{ user.alias }}" *ngFor="let user of usersSelect">
																{{ user.first }}
																{{ user.last }}
															</option>
														</select>
													</div>
													<div class="col-2">
														<label class="form-label">Contract number *</label>
														<select class="form-control money-green" formControlName="contract" [class.is-invalid]="formBasicInfo.get('contract').touched && formBasicInfo.get('contract').invalid" [class.is-valid]="formBasicInfo.get('contract').touched && formBasicInfo.get('contract').valid">
															<option value="">Select contract</option>
															<option value="{{ contractOp.NumContract }}" *ngFor="let contractOp of allcontracts">
																{{ contractOp.NumContract }}
																-
																{{ contractOp.name_customer }}
																-
																{{ contractOp.company_name }}
															</option>
														</select>
													</div>
													<div class="col-2">
														<label class="form-label">Campaign type *</label>
														<select class="form-control money-green" formControlName="campaign_type" [class.is-invalid]="formBasicInfo.get('campaign_type').touched && formBasicInfo.get('campaign_type').invalid" [class.is-valid]="formBasicInfo.get('campaign_type').touched && formBasicInfo.get('campaign_type').valid">
															<option value="D">Default</option>
															<option value="R">Reserve</option>
															<option value="H">Hourly</option>
														</select>
													</div>
													<div class="col-2">
														<label class="form-label">Prospects type *</label>
														<select class="form-control money-green" formControlName="prospects_type" [class.is-invalid]="formBasicInfo.get('prospects_type').touched && formBasicInfo.get('prospects_type').invalid" [class.is-valid]="formBasicInfo.get('prospects_type').touched && formBasicInfo.get('prospects_type').valid">
															<option value="B2B">B2B</option>
															<option value="B2C">B2C</option>
															<option value="PROSPECTING">PROSPECTING</option>
														</select>
													</div>
												</div>

												<div class="row mt-3">
													<div class="col-md-2 col-sm-12">
														<label class="form-label">Callback Number *</label>
														<input class="form-control money-green" type="number" formControlName="callback_no" [class.is-invalid]="formBasicInfo.get('callback_no').touched && formBasicInfo.get('callback_no').invalid" [class.is-valid]="formBasicInfo.get('callback_no').touched && formBasicInfo.get('callback_no').valid" />
													</div>
													<div class="col-md-2 col-sm-12">
														<label class="form-label">Time Zone *</label>
														<select class="form-control money-green" formControlName="timezone" [class.is-invalid]="formBasicInfo.get('timezone').touched && formBasicInfo.get('timezone').invalid" [class.is-valid]="formBasicInfo.get('timezone').touched && formBasicInfo.get('timezone').valid">
															<option value="">Select time zone</option>
															<option value="{{ timezone.shortName }}" *ngFor="let timezone of timezones">
																{{ timezone.name }}
															</option>
														</select>
													</div>
													<div class="col-md-1 col-sm-12">
														<label class="form-label">Points</label>
														<input class="form-control money-green" type="number" formControlName="points" />
													</div>

													<div class="col-md-2 col-sm-12">
														<label class="form-label">Industry *</label>
														<select class="form-control money-green" formControlName="industry" [class.is-invalid]="formBasicInfo.get('industry').touched && formBasicInfo.get('industry').invalid" [class.is-valid]="formBasicInfo.get('industry').touched && formBasicInfo.get('industry').valid">
															<option value="">Select industry</option>
															<option *ngFor="let industry of industries" [value]="industry.id">
																{{ industry.description }}
															</option>
														</select>
													</div>

													<div class="col-md-5 col-sm-12">
														<label class="form-label">Appointment Type *</label>
														<div style="padding-top: 10px">
															<span *ngFor="let type of types" class="selectors" style="margin-right: 30px" (click)="type.selected = !type.selected; setTypes(type.id)">
																<i
																	class="fa fa-square-o"
																	aria-hidden="true"
																	[ngClass]="{
																		'fa-square-o': !typesContain(type.id),
																		'fa-check-square-o': typesContain(type.id)
																	}"
																></i
																>{{ type.description }}
															</span>
														</div>
													</div>
												</div>

												<div class="row mt-3">
													<div class="col-md-3 col-sm-3">
														<label class="form-label">Source *</label>
														<select class="form-control money-green" formControlName="source" [class.is-invalid]="formBasicInfo.get('source').touched && formBasicInfo.get('source').invalid" [class.is-valid]="formBasicInfo.get('source').touched && formBasicInfo.get('source').valid">
															<option value="">Select source</option>
															<option value="T3direct Marketing">T3direct Marketing</option>
															<option value="401k Depot">401k Depot</option>
															<option value="Toplead">Toplead</option>
														</select>
													</div>

													<div class="col-3">
														<label class="form-label">Lead Cost *</label>
														<div class="input-group mb-3">
															<div class="input-group-prepend">
																<span class="input-group-text" id="basic-addon1"><i class="ri-money-dollar-circle-fill" style="font-size: 15px"></i></span>
															</div>
															<input type="number" step="2" class="form-control money-green" placeholder="Cost Per Lead" formControlName="lead_cost" [class.is-invalid]="formBasicInfo.get('lead_cost').touched && formBasicInfo.get('lead_cost').invalid" [class.is-valid]="formBasicInfo.get('lead_cost').touched && formBasicInfo.get('lead_cost').valid" />
														</div>
													</div>

													<div class="col-2">
														<label class="form-label">Appointments per Month *</label>
														<input type="number" class="form-control money-green" formControlName="appts_month" [class.is-invalid]="formBasicInfo.get('appts_month').touched && formBasicInfo.get('appts_month').invalid" [class.is-valid]="formBasicInfo.get('appts_month').touched && formBasicInfo.get('appts_month').valid" />
													</div>
													<div class="col-1">
														<label class="form-label">Week 1</label>
														<input type="number" class="form-control money-green" formControlName="week_1" />
													</div>
													<div class="col-1">
														<label class="form-label">Week 2</label>
														<input type="number" class="form-control money-green" formControlName="week_2" />
													</div>
													<div class="col-1">
														<label class="form-label">Week 3</label>
														<input type="number" class="form-control money-green" formControlName="week_3" />
													</div>
													<div class="col-1">
														<label class="form-label">Week 4</label>
														<input type="number" class="form-control money-green" formControlName="week_4" />
													</div>
												</div>

												<div class="row mt-3">
													<div class="col-12">
														<label class="form-label">Billing Notes</label>
														<input type="text" class="form-control money-green" placeholder="Billing Notes" formControlName="billing_notes" />
													</div>
												</div>

												<div class="row mt-3">
													<div class="col-12">
														<label class="form-label">Campaign Notes</label>
														<textarea rows="5" class="form-control money-green" placeholder="Campaign notes" formControlName="campaign_notes"></textarea>
													</div>
												</div>
											</div>
										</form>
									</ng-template>
								</li>

								<li [ngbNavItem]="2">
									<a ngbNavLink> <i class="ri-calendar-2-fill me-1 align-bottom"></i>Criteria </a>
									<ng-template ngbNavContent>
										<div class="container container-margin">
											<div class="row">
												<div class="col-12">
													<h3>
														<strong>Campaign Criteria</strong>
													</h3>
												</div>
											</div>
											<hr />

											<div class="row mt-3">
												<div class="col-12">
													<span style="margin-right: 40px"><input type="radio" class="selectors" [(ngModel)]="criterias.prospects_from" value="LMS" /> LMS Data base</span>
													<span style="margin-right: 40px"><input type="radio" class="selectors" [(ngModel)]="criterias.prospects_from" value="CLIENT" /> Client List</span>
													<span><input type="radio" class="selectors" [(ngModel)]="criterias.prospects_from" value="BOTH" /> Both</span>

													<div *ngIf="criterias.prospects_from === 'LMS'" class="alert alert-info mt-3" style="font-weight: 800">This campaign is getting records from LMS Database</div>

													<div *ngIf="criterias.prospects_from === 'CLIENT'" class="alert alert-info mt-3" style="font-weight: 800">This campaign is getting records from a client List</div>
													<div *ngIf="criterias.prospects_from === 'BOTH'" class="alert alert-info mt-3" style="font-weight: 800">This campaign is getting records from LMS Database and client list</div>
												</div>
											</div>
											<hr />
											<div class="row">
												<div class="col-2">
													<span class="form-check form-switch">
														<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck1" (click)="criteriaSelected('employee_size')" />
														Employee Size
													</span>
												</div>
												<div class="col-2">
													<span class="form-check form-switch">
														<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" (click)="criteriaSelected('asset_size')" />
														Asset Size
													</span>
												</div>
												<div class="col-2">
													<span class="form-check form-switch">
														<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck3" (click)="criteriaSelected('plan_participants')" />
														Plan participants
													</span>
												</div>
												<div class="col-2">
													<span class="form-check form-switch">
														<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck4" (click)="criteriaSelected('state')" />
														State
													</span>
												</div>
												<div class="col-2">
													<span class="form-check form-switch">
														<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck5" (click)="criteriaSelected('zip_code')" />
														Zip Code
													</span>
												</div>
											</div>
											<hr />
											<form [formGroup]="formCriteria">
												<div class="row" *ngIf="criterias.state_selected || criterias.zip_code_selected">
													<div class="col-4" *ngIf="criterias.state_selected">
														<h3 style="margin-top: 0px">State</h3>
														<select class="form-control money-green" formControlName="state" [class.is-invalid]="formCriteria.get('state').touched && formCriteria.get('state').invalid" [class.is-valid]="formCriteria.get('state').touched && formCriteria.get('state').valid">
															<option value="{{ state }}" *ngFor="let state of states">
																{{ state }}
															</option>
														</select>
													</div>
													<div class="col-4" *ngIf="criterias.zip_code_selected">
														<h3 style="margin-top: 0px">Zip Codes</h3>
														<div class="input-group mb-3">
															<div class="input-group-prepend">
																<span class="input-group-text"><i class="ri-map-pin-fill"></i></span>
															</div>
															<input type="number" class="form-control money-green" placeholder="Zip Code" formControlName="zip_code" [class.is-invalid]="formCriteria.get('zip_code').touched && formCriteria.get('zip_code').invalid" [class.is-valid]="formCriteria.get('zip_code').touched && formCriteria.get('zip_code').valid" />
														</div>
													</div>
													<div class="col-4" *ngIf="criterias.zip_code_selected">
														<h3 style="margin-top: 0px">Radius</h3>
														<div class="input-group mb-3">
															<div class="input-group-prepend">
																<span class="input-group-text"><i class="ri-gradienter-line"></i></span>
															</div>
															<input type="number" class="form-control money-green" placeholder="Radius in Miles" formControlName="radius" [class.is-invalid]="formCriteria.get('radius').touched && formCriteria.get('radius').invalid" [class.is-valid]="formCriteria.get('radius').touched && formCriteria.get('radius').valid" />
														</div>
													</div>
												</div>
												<hr *ngIf="criterias.employee_size" />
												<div class="row" *ngIf="criterias.employee_size">
													<div class="col-12">
														<div style="margin-top: 0px">
															<h2>Employee Size</h2>
															<span class="form-check form-switch mt-3">
																<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck1" (click)="limitSelected('employee_size')" />
																Add Limit
															</span>
														</div>
													</div>
												</div>
												<div class="row" *ngIf="criterias.employee_size">
													<div class="col-6">
														<label class="form-label">Minimum *</label>
														<div class="input-group mb-3">
															<div class="input-group-prepend">
																<span class="input-group-text"><i class="ri-group-2-fill"></i></span>
															</div>
															<input type="number" class="form-control money-green" placeholder="Employee Size Min" formControlName="employee_size_min" [class.is-invalid]="formCriteria.get('employee_size_min').touched && formCriteria.get('employee_size_min').invalid" [class.is-valid]="formCriteria.get('employee_size_min').touched && formCriteria.get('employee_size_min').valid" />
														</div>
													</div>
													<div class="col-6" *ngIf="criteriasLimits.employee_size">
														<label class="form-label">Maximum *</label>
														<div class="input-group mb-3">
															<div class="input-group-prepend">
																<span class="input-group-text"><i class="ri-group-2-fill"></i></span>
															</div>
															<input type="number" class="form-control money-green" placeholder="Employee Size Max" formControlName="employee_size_max" [class.is-invalid]="formCriteria.get('employee_size_max').touched && formCriteria.get('employee_size_max').invalid" [class.is-valid]="formCriteria.get('employee_size_max').touched && formCriteria.get('employee_size_max').valid" />
														</div>
													</div>
												</div>
												<hr *ngIf="criterias.employee_size" />

												<div class="row" *ngIf="criterias.asset_size">
													<div class="col-12">
														<h2 style="margin-top: 0px">Asset Size</h2>
														<span class="form-check form-switch mt-3">
															<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck1" (click)="limitSelected('asset_size')" />
															Add Limit
														</span>
													</div>
												</div>
												<div class="row" *ngIf="criterias.asset_size">
													<div class="col-6">
														<label class="form-label">Minimum *</label>
														<div class="input-group mb-3">
															<div class="input-group-prepend">
																<span class="input-group-text"><i class="ri-money-dollar-box-fill"></i></span>
															</div>
															<input type="number" class="form-control money-green" placeholder="Asset Size Min" formControlName="asset_size_min" [class.is-invalid]="formCriteria.get('asset_size_min').touched && formCriteria.get('asset_size_min').invalid" [class.is-valid]="formCriteria.get('asset_size_min').touched && formCriteria.get('asset_size_min').valid" />
														</div>
													</div>
													<div class="col-6" *ngIf="criteriasLimits.asset_size">
														<label class="form-label">Maximum *</label>
														<div class="input-group mb-3">
															<div class="input-group-prepend">
																<span class="input-group-text"><i class="ri-money-dollar-box-fill"></i></span>
															</div>
															<input type="number" class="form-control money-green" placeholder="Assets Size Max" formControlName="asset_size_max" [class.is-invalid]="formCriteria.get('asset_size_max').touched && formCriteria.get('asset_size_max').invalid" [class.is-valid]="formCriteria.get('asset_size_max').touched && formCriteria.get('asset_size_max').valid" />
														</div>
													</div>
												</div>
												<hr *ngIf="criterias.plan_participants" />

												<div class="row" *ngIf="criterias.plan_participants">
													<div class="col-12">
														<h2 style="margin-top: 0px">Plan Participants</h2>
														<span class="form-check form-switch mt-3">
															<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck1" (click)="limitSelected('plan_participants')" />
															Add Limit
														</span>
													</div>
												</div>
												<div class="row" *ngIf="criterias.plan_participants">
													<div class="col-6">
														<label class="form-label">Minimun *</label>
														<div class="input-group mb-3">
															<div class="input-group-prepend">
																<span class="input-group-text"><i class="ri-pie-chart-2-fill"></i></span>
															</div>
															<input type="number" class="form-control money-green" placeholder="Plan Participants Min" formControlName="plan_participants_min" [class.is-invalid]="formCriteria.get('plan_participants_min').touched && formCriteria.get('plan_participants_min').invalid" [class.is-valid]="formCriteria.get('plan_participants_min').touched && formCriteria.get('plan_participants_min').valid" />
														</div>
													</div>
													<div class="col-6" *ngIf="criteriasLimits.plan_participants">
														<label class="form-label">Maximum *</label>
														<div class="input-group mb-3">
															<div class="input-group-prepend">
																<span class="input-group-text"><i class="ri-pie-chart-2-fill"></i> </span>
															</div>
															<input type="number" class="form-control money-green" placeholder="Plan Participants Max" formControlName="plan_participants_max" [class.is-invalid]="formCriteria.get('plan_participants_max').touched && formCriteria.get('plan_participants_max').invalid" [class.is-valid]="formCriteria.get('plan_participants_max').touched && formCriteria.get('plan_participants_max').valid" />
														</div>
													</div>
												</div>
											</form>
											<hr *ngIf="criterias.plan_participants" />
										</div>
									</ng-template>
								</li>

								<li [ngbNavItem]="3">
									<a ngbNavLink> <i class="ri-article-line me-1 align-bottom"></i>Call Sheet </a>
									<ng-template ngbNavContent>
										<form [formGroup]="formCampaignInfo">
											<div class="container container-margin">
												<div class="row">
													<div class="col-12">
														<h3>
															<strong>Call sheet</strong>
														</h3>
													</div>
												</div>
												<hr />
												<div class="row">
													<div class="col-md-6 mb-3">
														<!-- Radio Buttons -->
														<div class="btn-group" role="group" aria-label="Basic radio toggle button group">
															<input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked="" (click)="callSheetTab = 'bio'" />
															<label class="btn btn-outline-secondary" for="btnradio1">Bio/Script</label>

															<input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" (click)="callSheetTab = 'notes'" />
															<label class="btn btn-outline-secondary" for="btnradio2">Notes</label>

															<input type="radio" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off" (click)="callSheetTab = 'details'" />
															<label class="btn btn-outline-secondary" for="btnradio3">Company Info</label>
														</div>
													</div>
												</div>
												<ng-container *ngIf="callSheetTab === 'notes'">
													<div class="row">
														<div class="col-md-12 col-sm-12">
															<div class="form-group">
																<label class="call-sheet-title">Who's Attending the Meetings?</label>
																<div class="value-txt">
																	<input formControlName="attending" class="form-control border-input money-green" type="text" />
																</div>
															</div>
														</div>
													</div>
													<div class="row mt-3">
														<div class="col-md-12 col-sm-12">
															<div class="form-group">
																<label class="call-sheet-title">General Notes:</label>
																<div class="value-txt text-danger">
																	<textarea rows="4" cols="50" formControlName="notes" class="form-control border-input money-green" type="text"></textarea>
																</div>
															</div>
														</div>
													</div>
													<div class="row mt-3">
														<div class="col-md-12 col-sm-12">
															<div class="form-group">
																<label class="call-sheet-title">Scheduling Notes:</label>
																<div class="value-txt">
																	<textarea rows="4" cols="50" formControlName="scheduling" class="form-control border-input money-green" type="text"></textarea>
																</div>
															</div>
														</div>
													</div>
													<div class="row mt-3">
														<div class="col-md-12 col-sm-12">
															<div class="form-group">
																<label class="call-sheet-title">Qualifying Questions:</label>
																<div class="value-txt text-danger">
																	<textarea rows="4" cols="50" formControlName="questions" class="form-control border-input money-green" type="text"></textarea>
																</div>
															</div>
														</div>
													</div>
												</ng-container>

												<ng-container *ngIf="callSheetTab === 'bio'">
													<div class="row">
														<div class="col-md-12 col-sm-12">
															<div class="form-group">
																<label class="call-sheet-title">Script:</label>
																<div class="value-txt text-danger">
																	<textarea rows="4" cols="50" formControlName="script" class="form-control border-input money-green" type="text"></textarea>
																</div>
															</div>
														</div>
													</div>
													<div class="row mt-3">
														<div class="col-md-12 col-sm-12">
															<div class="form-group">
																<label class="call-sheet-title">Who We Are:</label>
																<div class="value-txt text-danger">
																	<textarea rows="4" cols="50" formControlName="who_we_are" class="form-control border-input money-green" type="text"></textarea>
																</div>
															</div>
														</div>
													</div>
													<div class="row mt-3">
														<div class="col-md-12 col-sm-12">
															<div class="form-group">
																<label class="call-sheet-title">What We Do:</label>
																<div class="value-txt text-danger">
																	<textarea rows="4" cols="50" formControlName="what_we_do" class="form-control border-input money-green" type="text"></textarea>
																</div>
															</div>
														</div>
													</div>
													<div class="row mt-3">
														<div class="col-md-12 col-sm-12">
															<div class="form-group">
																<label class="call-sheet-title">Why Us?</label>
																<div class="value-txt text-danger">
																	<textarea rows="4" cols="50" formControlName="why_us" class="form-control border-input money-green" type="text"></textarea>
																</div>
															</div>
														</div>
													</div>
													<div class="row mt-3">
														<div class="col-md-12 col-sm-12">
															<div class="form-group">
																<label class="call-sheet-title">Email Template 300 Characteres</label>
																<div class="value-txt text-danger">
																	<textarea rows="4" cols="50" formControlName="email_template" class="form-control border-input money-green" type="text"></textarea>
																</div>
															</div>
														</div>
													</div>
												</ng-container>

												<ng-container *ngIf="callSheetTab === 'details'">
													<div class="row">
														<div class="col-md-6 col-sm-6">
															<div class="form-group">
																<label class="call-sheet-title">Company Website:</label>
																<div class="value-txt">
																	<input formControlName="website_url" class="form-control border-input money-green" type="text" />
																</div>
															</div>
														</div>
														<div class="col-md-6 col-sm-6">
															<div class="form-group">
																<label class="call-sheet-title">Additional Calendar URL:</label>
																<div class="value-txt">
																	<input formControlName="additional_calendar_url" class="form-control border-input money-green" type="text" />
																</div>
															</div>
														</div>
													</div>
													<div class="row mt-3">
														<div class="col-md-6 col-sm-6">
															<div class="form-group">
																<label class="call-sheet-title">Address 1:</label>
																<div class="value-txt">
																	<input formControlName="address_1" class="form-control border-input money-green" type="text" />
																</div>
															</div>
														</div>
														<div class="col-md-6 col-sm-6">
															<div class="form-group">
																<label class="call-sheet-title">Address 2:</label>
																<div class="value-txt">
																	<input formControlName="address_2" class="form-control border-input money-green" type="text" />
																</div>
															</div>
														</div>
													</div>
													<div class="row mt-3">
														<div class="col-md-6 col-sm-6">
															<div class="form-group">
																<label class="call-sheet-title">City:</label>
																<div class="value-txt">
																	<input formControlName="city" class="form-control border-input money-green" type="text" />
																</div>
															</div>
														</div>
														<div class="col-md-2 col-sm-2">
															<div class="form-group">
																<label class="call-sheet-title">State:</label>
																<div class="value-txt">
																	<input formControlName="state" class="form-control border-input money-green" type="text" maxlength="2" />
																</div>
															</div>
														</div>
														<div class="col-md-4 col-sm-4">
															<div class="form-group">
																<label class="call-sheet-title">Zip:</label>
																<div class="value-txt">
																	<input formControlName="zip" class="form-control border-input money-green" type="text" maxlength="6" />
																</div>
															</div>
														</div>
													</div>
												</ng-container>
											</div>
										</form>
									</ng-template>
								</li>

								<!-- <a class="navbar-brand nav-btn" [ngClass]="{'active': activeTab === 'basic'}"
                                        (click)="activeTab = 'basic';"><i class="fa fa-address-card-o mr-1"></i> Basic</a>


                                    <a class="navbar-brand nav-btn" [ngClass]="{'active': activeTab === 'criteria'}"
                                        (click)="activeTab = 'criteria';"><i class="fa fa-table mr-1"></i>Criteria</a>
                                    <a class="navbar-brand nav-btn" [ngClass]="{'active': activeTab === 'call_sheet'}"
                                        (click)="activeTab = 'call_sheet';"><i class="fa fa-file-text-o mr-1"></i>Call Sheet</a>
                                    <div class="collapse navbar-collapse" id="navbar-info">
                                        <ul class="navbar-nav ml-auto"></ul>
                                    </div> -->
							</ul>
							<!-- Tab panes -->
							<div class="tab-content text-muted">
								<div [ngbNavOutlet]="nav"></div>
							</div>
						</div>
					</div>
				</div>
				<hr />
				<div class="row">
					<div class="col-12" align="right">
						<button class="btn btn-success" (click)="validateCriterias()"><i class="fa fa-save"></i> SAVE</button>
					</div>
				</div>
			</div>
			<!-- end card-body -->
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!--end row-->
